import { render, staticRenderFns } from "./StudentDebtReport.vue?vue&type=template&id=1ae1adcf&scoped=true"
import script from "./StudentDebtReport.vue?vue&type=script&lang=js"
export * from "./StudentDebtReport.vue?vue&type=script&lang=js"
import style0 from "./StudentDebtReport.vue?vue&type=style&index=0&id=1ae1adcf&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1ae1adcf",
  null
  
)

export default component.exports